import type {BookingStatus} from '../api/types';
import type {MessageKey} from '../i18n/keys';

/**
 * Which statuses a guest can cancel from this surface.
 *
 * Only a live booking — `pending` or `confirmed`. An unrecognised status is
 * treated as **not** cancellable, which is the safe reading: the server is the
 * authority and answers 409 if a guess is wrong, so the client errs toward
 * hiding an action it is unsure of rather than offering one that will fail.
 */
export function isBookingCancellable(status: string): boolean {
  return status === 'pending' || status === 'confirmed';
}

const STATUS_KEY: Record<BookingStatus, MessageKey> = {
  pending: 'book.statusPending',
  confirmed: 'book.statusConfirmed',
  seated: 'book.statusSeated',
  completed: 'book.statusCompleted',
  cancelled: 'book.statusCancelled',
  no_show: 'book.statusNoShow',
};

/** The message key for a status pill. Unknown values get a neutral fallback. */
export function statusMessageKey(status: string): MessageKey {
  return (STATUS_KEY as Record<string, MessageKey>)[status] ?? 'book.statusUnknown';
}
